import { useAuthContext } from '@asgardeo/auth-react';

export function useAsgardeoAuth() {
  const { state, signIn, signOut, getBasicUserInfo } = useAuthContext();

  return {
    isAuthenticated: state?.isAuthenticated,
    isLoading: state?.isLoading,
    signIn,
    signOut,
    getUserInfo: getBasicUserInfo
  };
}
